module.exports = __webpack_public_path__ + "static/media/exam.d89a12ca.svg";